import type { RouteRecordRaw } from 'vue-router'
import type { RouterConfig } from 'nuxt/schema'
import routes from '@router/routes'

// Nuxt's router serves the existing route list until the pages move to `app/pages` in Story 5.
export default {
    routes: () => routes as RouteRecordRaw[],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) return { el: to.hash }
        // 'instant': html { scroll-behavior: smooth } reaches the window scroll at every tier,
        // and a route change should land, not glide.
        if (savedPosition) return { ...savedPosition, behavior: 'instant' }
        else return { left: 0, top: 0, behavior: 'instant' }
    },
} satisfies RouterConfig
